/**
 * "Personal Email Message" — the respondent's free text block, stored at
 * answers_json.personal_message (PRD 2026-09 Feature A). Surfaced as a
 * pseudo-question column; this module is the one place its id, label, and
 * report opt-in rule live.
 */

export const PERSONAL_MESSAGE_COLUMN_ID = 'personal_message';
export const PERSONAL_MESSAGE_COLUMN_LABEL = 'Personal Email Message';

export interface PersonalMessageQuestion {
  id: typeof PERSONAL_MESSAGE_COLUMN_ID;
  label: typeof PERSONAL_MESSAGE_COLUMN_LABEL;
  type: 'long_text';
  options: never[];
}

export function personalMessageQuestion(): PersonalMessageQuestion {
  return {
    id: PERSONAL_MESSAGE_COLUMN_ID,
    label: PERSONAL_MESSAGE_COLUMN_LABEL,
    type: 'long_text',
    options: []
  };
}

/** Whether the item's builder enabled the Respondent Free Text Block. */
export function personalMessageEnabled(definition: any): boolean {
  return definition?.legislator_contact?.email_template?.free_text_enabled === true;
}

/**
 * Report semantics are strictly opt-in: an empty/absent response_columns
 * selection means "all columns" — and "all" NEVER includes the personal
 * message; only an explicit selection does. This keeps every pre-existing
 * report (including live public share links) rendering exactly as before.
 */
export function personalMessageExplicitlySelected(
  responseColumns: string[] | null | undefined
): boolean {
  return Array.isArray(responseColumns) && responseColumns.includes(PERSONAL_MESSAGE_COLUMN_ID);
}
